<template>
  <FilmTabs/>
</template>

<script>
const FilmTabs = () => import('@/components/FilmTabs.vue');

export default {
  name: 'ReportDetail',
  components: {
    FilmTabs,
  },
  data() {
    return {
      active: 0,
    };
  },
};
</script>
